import React from 'react'
import { Link, Text, Heading, Box, Container, Button } from 'pcln-design-system'
import { WebPBackgroundImage } from '@pcln/content-tile'
import LazyLoad from 'react-lazy-load'
import PropTypes from 'prop-types'

const CreditCard = ({
  titleText,
  bodyText,
  buttonText,
  image,
  imageWebP,
  legalText,
  buttonLink
}) => (
  <Box
    py={5}
    style={{
      borderBottom: '1px solid',
      borderColor: '#d1d6db'
    }}
  >
    <Container maxWidth={1280}>
      <Box textAlign={'center'} mb={4}>
        <Heading
          fontWeight='bold'
          fontSize={4}
          mb={3}
          color='text'
          dangerouslySetInnerHTML={{ __html: titleText }}
        />
        <Text
          fontSize={3}
          color='text.light'
          mb={3}
          dangerouslySetInnerHTML={{ __html: bodyText }}
        />
        <Link href={buttonLink}>
          <Button px={5} data-autobot-element-id='CREDIT_CARD_BUTTON'>{buttonText}</Button>
        </Link>
      </Box>
      <Box mb={4}>
        <Link href={buttonLink}>
          <LazyLoad debounce={false} throttle={50}>
            <WebPBackgroundImage
              image={image}
              imageWebP={imageWebP}
              height={'240px'}
              style={{
                backgroundSize: '380px 240px',
                backgroundColor: 'white'
              }}
              alt='Priceline Rewards Credit Card image'
            />
          </LazyLoad>
        </Link>
      </Box>
      <Text
        textAlign={'center'}
        fontSize={1}
        color='text.light'
        mb={3}
        dangerouslySetInnerHTML={{ __html: legalText }}
      />
    </Container>
  </Box>
)

CreditCard.propTypes = {
  titleText: PropTypes.string,
  bodyText: PropTypes.string,
  buttonText: PropTypes.string,
  image: PropTypes.string,
  imageWebP: PropTypes.string,
  legalText: PropTypes.string,
  buttonLink: PropTypes.string
}

export default CreditCard
